import AppConfig from '@app/libs/reactPdfJs/constants/AppConfig';
import { PdfAction } from '@app/libs/reactPdfJs/store/actions';
import { PDF_CLEAR_ALL_STATE, PDF_SCALE_NORMALIZE } from '@app/libs/reactPdfJs/store/actionTypes';

type PdfMaxScaleState = number;

const initialState: PdfMaxScaleState = AppConfig.scale.maxScale;

export default function reducer(state: PdfMaxScaleState = initialState, action: PdfAction) {
  switch (action.type) {
    case PDF_CLEAR_ALL_STATE:
      return initialState;
    case PDF_SCALE_NORMALIZE:
      return action.payload.maxScale;
    default:
      return state;
  }
}
